import { Link } from "react-router-dom";
import { MEDIA } from "../../constants/media";
import { ArrowRight, Building2, User } from "lucide-react";

export const CtaFinal = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-8 py-20">
    <div className="relative rounded-3xl overflow-hidden">
      {/* Background: Lisbon */}
      <img src={MEDIA.lisbon} alt="Lisboa, Portugal" loading="lazy"
        className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950/95 via-slate-950/80 to-slate-950/50" />

      <div className="relative grid md:grid-cols-2 gap-0">
        {/* Candidate */}
        <div className="p-10 sm:p-14 border-b md:border-b-0 md:border-r border-white/10">
          <div className="w-11 h-11 rounded-xl bg-amber-500 flex items-center justify-center mb-6">
            <User className="w-5 h-5 text-white" strokeWidth={1.75} />
          </div>
          <h3 className="font-heading font-black tracking-tighter text-2xl sm:text-3xl text-white">
            Procuras trabalho?  
          </h3>
          <p className="text-slate-400 mt-3 text-sm max-w-sm leading-relaxed">
            Cria conta gratis, carrega o CV uma vez e candidata-te a todas as vagas em Portugal com um clique.
            A IA análisa o teu CV e sugere melhorias para te destacares.
          </p>
          <Link data-testid="cta-candidato" to="/auth?tab=register"
            className="inline-flex items-center gap-2 mt-7 rounded-full h-12 px-7 bg-amber-500 hover:bg-amber-400 text-white font-semibold transition-colors">
            Começar agora <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {/* Company */}
        <div className="p-10 sm:p-14">
          <div className="w-11 h-11 rounded-xl bg-white/10 border border-white/20 flex items-center justify-center mb-6">
            <Building2 className="w-5 h-5 text-amber-400" strokeWidth={1.75} />
          </div>
          <h3 className="font-heading font-black tracking-tighter text-2xl sm:text-3xl text-white">
            Precisas de contratar?
          </h3>
          <p className="text-slate-400 mt-3 text-sm max-w-sm leading-relaxed">
            Publica gratis, deixa a IA escrever o anúncio e recebe candidatos ordenados por match score.
            Só pagas quando precisas de visibilidade extra.
          </p>
          <Link data-testid="cta-empresa" to="/auth?tab=register"
            className="inline-flex items-center gap-2 mt-7 rounded-full h-12 px-7 border border-white/30 text-white hover:bg-white/10 font-semibold transition-colors">
            Publicar uma vaga <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>

      {/* Bottom trust bar */}
      <div className="relative border-t border-white/10 px-10 sm:px-14 py-5 flex flex-wrap items-center gap-6">
        {["100% grátis para candidatos", "Moderação humana de vagas", "Protegido por RGPD", "IA em português de Portugal"].map((t) => (
          <div key={t} className="flex items-center gap-2 text-xs text-slate-400">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 shrink-0" />
            {t}
          </div>
        ))}
      </div>
    </div>
  </section>
);
